module.exports = __webpack_public_path__ + "img/q6.82f86765.svg";